export default __webpack_public_path__ + "static/media/cfdWorkIcon2.6d7d9dab.webp";